<template>
  <v-container>
    <v-row justify="center">
      <v-col
        :cols="12" :sm="8"
        justify="center"
      >
        <h1>{{ $t('content.secoEmployee.label') }}</h1>
        <p v-html="$t('content.secoEmployee.text')"></p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        :cols="12" :sm="8"
      >
        <h2>{{ $t('content.secoEmployee.conditions.label') }}</h2>
        <p v-html="$t('content.secoEmployee.conditions.list')"></p>
        <img :src="`${imagePath}jobs2share-bridge-off-season-${language}.png`" style="width: 100%; height: auto"/>
        <p v-html="$t('content.secoEmployee.moreInformation')"></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      imagePath: '/static/seco-pilot/',
    };
  },
  computed: {
    ...mapUserState([
      'language',
    ]),
  },
};
</script>
